import { Nullable } from '@xplan-pension-switching/common';

const isNullorUndefined = <T>(value?: Nullable<T>): boolean => value === null || value === undefined;

const isEmptyString = <T>(value: T): boolean => typeof value === 'string' && value === '';

const isEmptyCollection = <T>(value: T): boolean => (value instanceof Map || value instanceof Set) && value.size === 0;

const isEmptyObject = <T>(value: T): boolean =>
    typeof value === 'object' &&
    !(value instanceof Map) &&
    !(value instanceof Set) &&
    Object.keys(value as object).length === 0;

const isEmptyArray = <T>(value: T): boolean => Array.isArray(value) && value.length === 0;

export const isNullOrUndefinedOrEmpty = <T>(value?: Nullable<T>): boolean =>
    isNullorUndefined(value) ||
    isEmptyString(value) ||
    isEmptyCollection(value) ||
    isEmptyObject(value) ||
    isEmptyArray(value);
